module.exports = __webpack_public_path__ + "fonts/Outfit-ExtraBold.d649fd9b.ttf";